export default "__VITE_ASSET__DI5vZ44F__"